
export const sortedServiceQueues = (state) => {
  let serviceQueues = []
  if (state.service && state.service.queues) {
    Object.keys(state.service.queues).sort((a, b) => {
      if (a < b) {
        return -1
      } else if (a > b) {
        return 1
      } else {
        return 0
      }
    }).map((key, i) => {
      // Initialization with service known data
      serviceQueues[i] = {
        letter: key,
        enabled: state.service.queues[key].enabled,
        name: state.service.queues[key].name
      }
      // Mapping with current ticket and next ticket
      serviceQueues[i].currentTicket = state.currentTickets[key]
      serviceQueues[i].nextTicket = state.nextTickets[key]
    })
  } else {
    serviceQueues = null
  }
  return serviceQueues
}

export const availableServices = (state) => {
  if (state.services && state.loggedUser.roles.includes('admin')) {
    return state.services
  } else {
    if (state.services) {
      return state.services.filter((service) => {
        return Object.keys(state.loggedUser.acl).includes(service.id)
      })
    }
  }
}
